import ContentPage from "app/core/components/ContentPage"
import { promises as fs } from "fs"
import path from "path"

export async function getStaticProps() {
  const filePath = path.join(process.cwd(), "resources/aup.md")
  const fileContents = await fs.readFile(filePath, "utf8")
  return {
    props: {
      content: fileContents,
    },
  }
}
const AUPPage = ({ content }) => {
  return (
    <div>
      <ContentPage markdown={content} />
    </div>
  )
}

export default AUPPage
